import * as Sentry from '@sentry/nextjs';
import sharedSentryOptions from './shared-sentry-options';

export const initSentry = (additionalOptions: Parameters<typeof Sentry.init>[0]) =>
    Sentry.init({
        ...sharedSentryOptions,
        ...additionalOptions,
    });
